export const userDetail = () => {
  return [
    {
      field_name: "number",
      label: "Mobile",
      type: "phone",
      isRequired: true,
      min: 10,
      max: 10,
    },
  ];
};
export const userSubscribeEmail = () => {
  return [
    {
      field_name: "email",
      label: "Email",
      type: "email",
      isRequired: true,
    },
  ];
};
